
import React from 'react';
import moment from 'moment';

import { useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { Base64 } from 'js-base64';
import { Spin } from 'antd';

import { ILuxuryHome } from '@share/common-types';
import { RootState } from '@share/utils';
import { Routes } from '@share/constants';

import './style.scss';

interface IProps {
  home: ILuxuryHome;
  startDate: Date | null | undefined;
  endDate: Date | null | undefined;
  editDates: boolean;
}

export const LuxuryHomesDetailsActionPriceDetails: React.FC<IProps> = ({ home, startDate, endDate, editDates }) => {
  const history = useHistory();

  const { account} = useSelector((state: RootState) => state.loginStore);
  const { condo, error, loading } = useSelector((state: RootState) => state.  condoDetailsStore);

  const condoDetails = condo?.condoDetails;

  const { roomId } = useParams<{ roomId: string }>();

  const decodedRoomId = roomId ? Base64.decode(roomId) : undefined;

  const unit = home?.units?.[0];

  const goToCheckout = (propertyId: number, packageId: string) => {
    const roomId = Base64.encode(unit?.id);
    history.push(`/${account?.name}${Routes.LuxuryHomesCheckout}/${propertyId}/${roomId}/${packageId}${location.search}`);
  };

  const homeUnit = condoDetails?.units?.find((unit: any) => unit?.roomId === decodedRoomId);
  const availability = homeUnit?.availibilities?.[0];

  const nights = moment(endDate).diff(moment(startDate), 'days');
  const amount = availability?.price;
  const availabilityTaxes = availability?.taxes;
  const availabilityTaxesReduced = availabilityTaxes?.reduce((a: any, b: any) => a + b?.amount, 0);
  const taxes = availabilityTaxes ? 
                    availabilityTaxesReduced : 
                    availability?.maxWalletClientCash ? 
                        availability?.price - availability?.maxWalletClientCash : 
                        0;
  const total = amount - taxes;

  if (!condoDetails || editDates) {
    return null;
  }

  const hasAvailabilityTaxes = availabilityTaxes?.length > 0;

  return (  
    <>
      <p className="booking-sidebar__detail-value" style={{ marginTop: 15 }}>
        <strong>Arrive:</strong>
        <label>{startDate ? moment(startDate).format('MMM D, YYYY') : ''}</label>
      </p>

      <p className="booking-sidebar__detail-value">
        <strong>Depart:</strong>
        <label>{endDate ? moment(endDate).format('MMM D, YYYY') : ''}</label>
      </p>

      <p className="booking-sidebar__detail-value">
        <strong>Trip Length:</strong>
        <label>{nights} night{nights > 1 ? 's' : ''}</label>
      </p>

      <p className="booking-sidebar__detail-value">
        <strong>Best Available Rate:</strong>
        <label>$ {Math.floor(total * 100) / 100}</label>
      </p>

      <p className="booking-sidebar__detail-value" style={{ marginBottom: hasAvailabilityTaxes ? 3 : 15, borderBottom: hasAvailabilityTaxes ? '1px solid #e0e0e0' : 'none' }}>
        <strong>Taxes:</strong>
        <label>$ {Math.floor(taxes * 100) / 100}</label>
      </p>

      {hasAvailabilityTaxes && 
        availabilityTaxes.map((tax: any, index: number) => (
          <p key={index} className="booking-sidebar__detail-value grey-text" style={{ marginBottom: index === availabilityTaxes?.length - 1 ? 15 : 3, borderBottom: index === availabilityTaxes?.length - 1 ? '1px solid #e0e0e0' : 'none' }}>
            <strong>{tax.type}:</strong>
            <label>$ {Math.floor(tax.amount * 100) / 100}</label>
          </p>))}

      <p className="booking-sidebar__detail-value" style={{ marginBottom: 35 }}>
        <strong>Total:</strong>
        <label>$ {Math.floor(amount * 100) / 100}</label>
      </p>

      <Spin spinning={loading}>
        <button
          className="book-vacation"
          disabled={!isEmpty(error) || loading}
          onClick={() => goToCheckout(home?.id, availability?.id)}
        >
          BOOK YOUR VACATION
        </button>
      </Spin>
    </>
  );
};
